import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class ExchangeRateGreaterThanZeroError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.common.validation.exchange-rate.rate.exchange-rate-should-be-greater-than-zero');
    }
}
